import React, { useState } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';

const testimonials = [
  {
    name: 'Sarah L.',
    quote: 'Adding a VendPro machine to our office was the best decision! Employees love the convenience and it pays for itself.',
  },
  {
    name: 'Mike D.',
    quote: 'I started with one vending machine and now have five. The support and reliability are unmatched.',
  },
  {
    name: 'Jessica R.',
    quote: 'The machine is sleek, easy to use, and my customers are happy. Highly recommend VendPro!',
  },
  {
    name: 'Carlos M.',
    quote: 'VendPro made it easy to get started. The training and support are top-notch. I’m earning passive income every month!',
  },
  {
    name: 'Linda S.',
    quote: 'We placed a machine in our gym and it’s been a hit. The cashless payment system is a game changer.',
  },
];

const modalTestimonials = [
  {
    name: 'John T.',
    quote: 'The attention to detail from the VendPro team is outstanding. They helped me choose the perfect machine for my location.',
  },
  {
    name: 'Emily C.',
    quote: "I was new to the vending business, but VendPro's quality advice and support made the process seamless.",
  },
  {
    name: 'David R.',
    quote: 'The quality of the machines is top-notch. They are reliable and require minimal maintenance.',
  },
  {
    name: 'Maria G.',
    quote: 'I appreciate the personalized service I received. The team was always available to answer my questions.',
  },
  {
    name: 'Brian K.',
    quote: 'The installation was quick and professional. The machine was up and running in no time.',
  },
  {
    name: 'Laura W.',
    quote: 'The variety of products I can offer in my machine is fantastic. My customers love the selection.',
  },
  {
    name: 'Kevin H.',
    quote: 'The reporting features make it easy to track sales and inventory. It helps me optimize my business.',
  },
  {
    name: 'Sophia N.',
    quote: 'I was hesitant at first, but the team at VendPro provided me with all the information I needed to make an informed decision.',
  },
  {
    name: 'Daniel F.',
    quote: 'The machine has been a great addition to my laundromat. It provides a great service to my customers.',
  },
  {
    name: 'Olivia P.',
    quote: 'The quality of the advice I received was invaluable. I would recommend VendPro to anyone looking to get into the vending business.',
  },
  {
    name: 'Matthew B.',
    quote: 'The team is passionate about what they do, and it shows in the quality of their products and service.',
  },
  {
    name: 'Ava M.',
    quote: 'I am so glad I chose VendPro. They have exceeded my expectations in every way.',
  },
  {
    name: 'Grace E.',
    quote: 'The attention to detail in the design of the machine is impressive. It looks great in my salon.',
  },
];

function TestimonialsPage() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="container mx-auto py-8 md:py-12 px-4">
      <div className="bg-blue-50 py-16 md:py-24 mb-24">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h1 className="text-3xl md:text-5xl font-extrabold text-blue-800 mb-4">Customer Success Stories</h1>
            <p className="text-lg md:text-2xl text-gray-700 mb-8">See how VendPro is helping people just like you earn more and stress less.</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 justify-center">
            {testimonials.map((t, idx) => (
              <div
                key={idx}
                className={`relative bg-white border-t-4 border-blue-600 rounded-xl shadow-lg p-8 flex flex-col items-center text-center transition-transform duration-300 hover:scale-105 ${
                  idx === 1 ? 'md:translate-y-8' : ''
                }`}
              >
                {/* Decorative quote icon */}
                <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-blue-600 text-white rounded-full p-2 shadow-lg">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17V7a4 4 0 014-4h0a4 4 0 014 4v10" />
                  </svg>
                </div>
                {/* Initials circle */}
                <div className="mb-4 mt-2">
                  <div className="w-12 h-12 bg-blue-100 text-blue-800 rounded-full flex items-center justify-center text-xl font-bold shadow">
                    {t.name.split(' ').map(n => n[0]).join('')}
                  </div>
                </div>
                <p className="italic mb-6 text-gray-700 text-lg md:text-xl leading-relaxed">"{t.quote}"</p>
                <div className="font-semibold text-blue-700 text-base md:text-lg">{t.name}</div>
              </div>
            ))}
          </div>
          <div className="text-center mt-8">
            <button
              onClick={openModal}
              className="bg-blue-800 text-white font-bold py-3 px-6 rounded text-lg hover:bg-blue-700 transition duration-300 mt-4"
            >
              See More Reviews
            </button>
          </div>
        </div>
      </div>
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg p-8 max-w-xl w-full">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-bold text-blue-800">More Customer Reviews</h2>
              <button onClick={closeModal} className="text-gray-500 hover:text-gray-700">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
            <Carousel
              showThumbs={false}
              showStatus={false}
              infiniteLoop
              useKeyboardArrows
              autoPlay
              interval={5000}
            >
              {modalTestimonials.map((t, idx) => (
                <div className="p-4" key={idx}>
                  <p className="italic text-lg mb-4">"{t.quote}"</p>
                  <p className="font-semibold text-blue-700">- {t.name}</p>
                </div>
              ))}
            </Carousel>
          </div>
        </div>
      )}
    </div>
  );
}

export default TestimonialsPage;
 